import { ERROR, LOADING, READY, useVisualState } from '../../../hooks/useVisualState'
import { Route, useHistory, useParams } from 'react-router-dom'
import React, { useCallback, useEffect } from 'react'
import PlayerCard from '../../../components/Cards/PlayerCard/PlayerCard'
import convertDate from '../../../helpers/DateHelper'
import { oldGet } from '../../../helpers/requestOld'
import Button from '../../../components/Button/Button'
import './TeamView.scss'
import LoadingPanel from '../../../components/Loading/LoadingPanel'
import OldPlayerFormModal from '../OldCm/OldPlayerFormModal'
import useForceUpdate from '../../../hooks/useForceUpdate'
import TextLink from '../../../components/TextLink/TextLink'
import Logo from '../../../components/Logo/Logo'
import Modal from '../../../components/Modal/Modal'
import ModalHeader from '../../../components/Modal/ModalHeader'
import ModalContent from '../../../components/Modal/ModalContent'
import t from '../../../helpers/i18n'

const TeamView = () => {
  const history = useHistory()
  const { competitionId, teamId } = useParams()
  const [[teamState, team], setTeam] = useVisualState()
  const [update, forceUpdate] = useForceUpdate()

  const handleOpenPlayer = useCallback((player_id) => {
    history.push('/soccer/competition/' + competitionId + '/team/' + teamId + '/player/' + player_id)
  }, [history, competitionId, teamId])

  const handleRegisterPlayer = useCallback(() => {
    history.push('/soccer/competition/' + competitionId + '/team/' + teamId + '/new_player')
  }, [history, competitionId, teamId])

  const handleClose = useCallback(() => {
    history.push('/soccer/competition/' + competitionId + '/team/' + teamId)
  }, [history, competitionId, teamId])

  const handleNewPlayer = useCallback(() => {
    forceUpdate()
  }, [forceUpdate])

  useEffect(() => {
    setTeam(LOADING)
    oldGet('/cm/categories/' + competitionId + '/team/' + teamId)
      .then((response) => {
        setTeam(READY, response)
      })
      .catch((error) => {
        setTeam(ERROR, error)
      })
  }, [setTeam, competitionId, teamId, update])

  return (
    <div className="main-content team-view-page">
      <div className="-page-header">
        <div className="-title">
          <TextLink
            label="← Regresar a competiciones"
            labelOrientation="right"
            size="small"
            icon="ArrowLeftIcon"
            link={"/soccer/competition/" + competitionId}
          />
          <div className="-left label-display-medium-semibold">{team?.name}</div>
          <div className="-competition">
            <div className='-data proper-noun-small-medium'>{team?.competition_name}</div>
            <div className='-logo'><Logo size="tiny" source={team?.competition_logo} /></div>
          </div>
        </div>
        <div className='-buttons'>
          <Button 
            type='dark'
            color='green'
            label="Registrar jugador"
            onClick={handleRegisterPlayer}
          />
        </div>
      </div>
      <div className='-heading'>
        <div className='-left overline-label-large-bold'>
          {t('titles.Players')}
        </div>
        <div className='-left label-small-basic'>
          ({(team && team.players.length) || ''})
        </div>
        <div className='-center'></div>
        {team?.registerOpen && team.limitPlayers > 0 &&
          <div className='-right label-small-basic'>
            Límite de {team.limitPlayers} jugadores
          </div>      
        }
        <div className='-right'>
          {team?.registerOpen && 
            <>
              <Button
                label={t('buttons.Add')}
                size='field-sized'
                type='dark'
                color='green'
                icon='GetIcon'
                onClick={handleRegisterPlayer}
              />
            </>
          }
          {team && !team.registerOpen && 
            <div className="caption-default-medium">Registro cerrado</div>          
          }
        </div>
      </div>

      <div className='-content'>
        {teamState === READY && team?.players && team?.players.map((player) => (
          <PlayerCard
            key={player.player_id}
            firstName={player.firstname}
            lastName={player.lastname}
            avatar={player.avatar}
            age={new Date().getFullYear() - new Date(player.birthdate).getFullYear()}
            birthDate={convertDate(player.birthdate)}
            onClick={() => handleOpenPlayer(player.player_id)}
          />
        ))}
        {teamState === READY && team?.players?.length === 0 &&
          <div>
            <div className="caption-default-medium">No hay jugadores registrados.</div>
          </div>          
        }
        {teamState === LOADING && <LoadingPanel/>}
      </div>
      <Route path="/soccer/competition/:competitionId/team/:teamId/new_player">
        {teamState === READY && (team.limitPlayers === 0 || team.limitPlayers > team.players.length) &&
          <OldPlayerFormModal 
            onCloseRequested={handleClose}
            onNewPlayer={handleNewPlayer}
          />
        }
        {teamState === READY && team.limitPlayers > 0 && team.limitPlayers <= team.players.length &&
          <Modal onCloseRequested={handleClose}>
            <ModalHeader title="Límite de Jugadores" back={false} />
            <ModalContent dialog>
              <div className="-message caption-small-basic">Se alcanzó el límite de jugadores permitido para los equipos en esta competición.</div>
            </ModalContent>
          </Modal>
        }
      </Route>
    </div>
  )
}

export default TeamView
